import IconButton from "@/ui/icon-button";
import clsx from "clsx";
import { useState } from "react";

interface HandleCopyEvent extends React.MouseEvent<HTMLButtonElement> {
  stopPropagation: () => void;
}

const CopyButton = ({
  value,
  className = "w-[1.125rem] h-[1.125rem]",
  iconClassName = "w-[0.5625rem] h-[0.5625rem]",
}: {
  value: string;
  className?: string;
  iconClassName?: string;
}) => {
  const [isCopying, setIsCopying] = useState<boolean>(false);

  const handleCopy = (event: HandleCopyEvent, value: string) => {
    event.stopPropagation();
    setIsCopying(true);

    navigator.clipboard.writeText(value);

    setTimeout(() => {
      setIsCopying(false);
    }, 1000);
  };

  return (
    <IconButton
      key={value}
      withHover={true}
      withBorder={false}
      name={isCopying ? "check" : "copyIcon"}
      variant="circle"
      className={clsx("bg-black rounded-full", className)}
      iconClassName={iconClassName}
      onClick={(event) => handleCopy(event, value)}
    />
  );
};

export default CopyButton;
